import Button from 'react-bootstrap/Button';

export default function CustomButton(props) {
    return(
        <Button className="btn-outline-mid-grey bg-dark-grey text-off-white fw-light fs-7 w-100" {...props}>{props.children}</Button>
    );
}